<template>
  <quizset-form>
    <ButtonUpdate class="mt_m"/>
    <ButtonDelete class="mt_s"/>
  </quizset-form>
</template>

<script>
import QuizsetForm from '@/components/Quizset/Form'
import ButtonUpdate from '@/components/Quizset/ButtonUpdate'
import ButtonDelete from '@/components/Quizset/ButtonDelete'

export default {
  components: {
    QuizsetForm,
    ButtonUpdate,
    ButtonDelete
  },

  created: async function () {
    await this.$store.dispatch(
      'quizset/getQuizset',
      this.$route.params.id
    )
    this.$store.dispatch('quizset/initForm')
  }
}
</script>
